function isFlipped(count: number, index: number): boolean {
    switch (count) {
        case 2:
        case 3:
            return count === index + 1;
        case 4:
            return index === 2 || index === 3;
        default:
            return false;
    }
}

export default isFlipped;
